module.exports = __webpack_public_path__ + "img/34.557ea35f.png";